import React from 'react';
import { useI18n } from 'react-simple-i18n';
import { Link } from 'react-router-dom';
import appstate, { getLocaledString } from '../appstate';
import stock2 from '../assets/img/stock/stock-2.jpg';
import stock3 from '../assets/img/workteam.png';
import stock4 from '../assets/img/stock/stock-4.jpeg';
import itm1 from '../assets/img/1.png';
import itm2 from '../assets/img/2.png';
import itm3 from '../assets/img/3.png';
import bulb from '../assets/img/bulb.png';
import PasicaComponent from '../components/pasicaComponent/pasicaComponent';
import FlipComponent from '../components/FlipComponent/FlipComponent';
import { MeasuresQuiz } from './measuresView';

export default function HomeView() {
	const { t } = useI18n();

	return (
		<div className={'w-full flex flex-col gap-32 -mb-8'} id={'frst-sc'}>
			<div
				className={
					'h-screen bg-white flex justify-center items-center flex-col'
				}
			>
				<div className={'flex flex-col h-full w-full'}>
					<div
						style={{ flex: 4 }}
						className={'h-full flex flex-col md:flex-row'}
					>
						<div
							className={
								'flex-1 relative w-full h-full overflow-hidden'
							}
						>
							<Link
								className={
									'text-center w-full scrr h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-4xl justify-center items-center flex flex-col'
								}
								to={'/employees-and-employers'}
							>
								{getLocaledString(
									'Zaposleni in zaposlene',
									'Employees',
								)}
							</Link>
							<img
								src={itm1}
								alt=""
								className={
									'absolute top-0 left-0 w-full h-full object-cover'
								}
							/>
						</div>
						<div
							className={
								'flex-1 relative w-full h-full  overflow-hidden'
							}
						>
							<Link
								to={'/leaders-in-org'}
								className={
									'text-center w-full scrr h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-4xl justify-center items-center flex flex-col'
								}
							>
								{getLocaledString(
									'Vodje v organizaciji',
									'Managers',
								)}
							</Link>
							<img
								src={itm2}
								alt=""
								className={
									'absolute top-0 left-0 w-full h-full object-cover'
								}
							/>
						</div>
					</div>
					<div style={{ flex: 2 }}>
						<div
							className={'relative w-full h-full overflow-hidden'}
						>
							<Link
								to={'/about-the-project'}
								className={
									'text-center w-full scrr h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-4xl justify-center items-center flex flex-col'
								}
							>
								{getLocaledString(
									'Projekt PROMETEJ',
									'The PROMETHEUS Project',
								)}
							</Link>
							<img
								src={itm3}
								alt=""
								className={
									'absolute top-0 left-0 w-full h-full object-cover'
								}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

/*
			<div
				className={'text-center mb-6'}
				style={{ marginBottom: '-40px' }}
			>
				<p
					className={'text-lg leading-8 leading-8 mb-12 mt-7'}
					dangerouslySetInnerHTML={{
						__html: t('home.section1.text'),
					}}
				></p>
				<Link
					to={appstate.routes().moreAboutProject.path}
					className={'button-primary'}
				>
					{t('home.section1.button')}
				</Link>
			</div>

			<div>
				<PasicaComponent
					title={t('home.section2.pasica')}
					h1={'selfevaltool'}
				/>

				<div
					className={'text-lg leading-8 leading-8 mb-12 text-center'}
					dangerouslySetInnerHTML={{
						__html: t('measures.subCaption'),
					}}
				/>

				<MeasuresQuiz />
			</div>

			<PasicaComponent title={t('home.section2.title')} />


			<div
				className={'grid grid-cols-12 grid-rows-4 gap-6 mb-2'}
				style={{ marginTop: '-7.5rem' }}
			>
				<div
					className={
						'lg:block hidden col-span-12 lg:col-span-7 row-span-4'
					}
				>
					<div
						className={
							'text-4xl font-bold text-primary-500 w-104 leading-12'
						}
					/>
				</div>
				<div
					className={'col-span-12 lg:col-span-5 row-span-4 relative'}
				>
					<img
						src={stock3}
						className={`absolute hidden lg:block top-0 z-10 ${
							appstate.currentLanguage() === 'slSI'
								? 'w-104 right-52'
								: 'w-96 right-44'
						} shadow rounded overflow-hidden`}
						alt={''}
					/>
					<img
						src={stock4}
						className={
							'hidden lg:block absolute right-0 w-72 h-auto shadow rounded overflow-hidden'
						}
						style={{ top: '-1rem' }}
						alt={''}
					/>
				</div>
				<div
					className={
						'col-span-12 lg:col-span-5 text-lg leading-8 mt-4'
					}
					style={{ marginTop: '-100px' }}
					dangerouslySetInnerHTML={{
						__html: t('home.section2.text1'),
					}}
				/>
				<div className={'col-span-7'} />
				<div
					className={
						'col-span-12 lg:col-span-5 text-lg leading-8 mt-12'
					}
					style={{ marginTop: '0px', paddingRight: '60px' }}
					dangerouslySetInnerHTML={{
						__html: t('home.section2.text2'),
					}}
				/>
				<div
					className={
						'col-span-12 flex flex-col lg:flex-row gap-6 mt-8'
					}
				>
					<Link
						className={'button-primary w-fit'}
						to={
							appstate.routes().measuresForWorkersAndEmployers
								.path + '#employers'
						}
					>
						{getLocaledString(
							'Ukrepi za vodje',
							'Measures for managers',
						)}
					</Link>
					<Link
						className={'button-primary w-fit'}
						to={
							appstate.routes().measuresForWorkersAndEmployers
								.path + '#employees'
						}
					>
						{appstate.currentLanguage() === 'slSI'
							? 'Ukrepi za zaposlene'
							: 'Measures for employees'}
					</Link>
				</div>
			</div>

			<PasicaComponent
				title={getLocaledString(
					'Izobraževalni moduli',
					'Educational modules',
				)}
			/>


			<div className={'flex flex-col mb-2 -mt-14'}>
				<div
					className={'flex flex-col lg:flex-row gap-6 mb-2'}
					style={{ marginTop: '-65px' }}
				>
					<div className={'flex-5 pr-12'}>
						<div
							className={'text-lg leading-8'}
							dangerouslySetInnerHTML={{
								__html: t('home.section3.text1'),
							}}
						/>
						<div
							className={'text-lg leading-8 mt-8'}
							dangerouslySetInnerHTML={{
								__html: t('home.section3.text2'),
							}}
						/>
						<div className={'py-10'}>
							<Link
								to={appstate.routes().educationalModules.path}
								className={'button-primary'}
							>
								{t('home.section3.button')}
							</Link>
						</div>
					</div>
					<div className={'flex-4'}>
						<img
							className={
								'object-cover w-full h-90 shadow rounded overflow-hidden'
							}
							src={stock2}
							alt=""
						/>
					</div>
				</div>
			</div>


			<div className={'hidden lg:flex flex-col b -mt-24 mb-6'}>
				<PasicaComponent
					title={getLocaledString('Abeceda', 'Dictionary')}
				/>
				<div
					className={'text-lg leading-8 mb-8 text-center'}
					dangerouslySetInnerHTML={{
						__html: t('home.section4.text1'),
					}}
				/>
				<div>
					<FlipComponent />
				</div>
			</div>


			<div className={'flex flex-col -mt-16 -mb-20'}>
				<PasicaComponent
					title={getLocaledString(
						'Ključne organizacije',
						'Key organizations',
					)}
				/>
				<div
					className={'text-lg leading-8'}
					dangerouslySetInnerHTML={{
						__html: t('home.section5.text1'),
					}}
				/>
				<div className={'flex flex-row justify-between mt-8'}>
					<div />
					<div>
						<Link
							to={appstate.routes().keyOrganizations.path}
							className={'button-primary'}
						>
							{t('home.section5.button')}
						</Link>
					</div>
				</div>
			</div>


			<div />

			<div className={'hidden'}>
				{appstate.orgs().map((org, index) => {
					return <img src={org.logo} alt="" key={index} />;
				})}
			</div>

      */
